import React, { useEffect, useRef } from 'react'
import { mintAddress, solanaRpcUrl } from '../config'

const PLATFORM_FEE_AND_ACCOUNTS = {
  referralAccount: 'EyX7rwaKyBYMqN9N3x29SYxzzzLJLVvHreV7L6fSnX77',
  feeBps: 100,
}

const Trade = () => {
  const jupRef = useRef(null)

  useEffect(() => {
    if (!jupRef?.current) return
    window?.Jupiter?.init({
      displayMode: 'integrated',
      integratedTargetId: 'integrated-terminal',
      endpoint: solanaRpcUrl,
      strictTokenList: false,
      useUserSlippage: false,
      formProps: {
        initialInputMint: 'So11111111111111111111111111111111111111112',
        initialOutputMint: mintAddress,
        initialSlippageBps: 110,
      },
      platformFeeAndAccounts: PLATFORM_FEE_AND_ACCOUNTS,
    })
  }, [jupRef])

  return (
    <div
      ref={jupRef}
      id="integrated-terminal"
      style={{ minHeight: '400px', display: 'flex' }}
    ></div>
  )
}

export default Trade
